export default __webpack_public_path__ + "static/balazs-ketyi-graphic-design-f0093484218c8711fd6d9396b39b8680.jpg";